"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Email_1 = tslib_1.__importDefault(require("@mui/icons-material/Email"));
const Smartphone_1 = tslib_1.__importDefault(require("@mui/icons-material/Smartphone"));
const Grid_1 = tslib_1.__importDefault(require("@mui/material/Grid"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const Avatar_1 = tslib_1.__importDefault(require("../Avatar"));
const getStyles = () => ({
    leftSide: {
        marginRight: (theme) => theme.spacing(2),
    },
    userInfoText: {
        marginBottom: (theme) => theme.spacing(0.5),
    },
});
const UserCardBase = (props) => {
    const { user, loading = false, showExtended = false, notAvailableMessage = "N/A", avatarComponentProps } = props;
    const styles = getStyles();
    const userName = user?.shortName || user?.userName;
    return (react_1.default.createElement(Grid_1.default, { container: true },
        react_1.default.createElement(Grid_1.default, { item: true },
            react_1.default.createElement(Avatar_1.default, { size: "large", alt: user?.name, loading: loading, sx: { "& .MuiAvatar-root": { mR: 2 } }, ...avatarComponentProps })),
        react_1.default.createElement(Grid_1.default, { item: true },
            react_1.default.createElement(Typography_1.default, { variant: "subtitle2", sx: styles.userInfoText }, user?.name),
            react_1.default.createElement(Typography_1.default, { color: "textSecondary", sx: styles.userInfoText }, `${user?.domain?.name}/${userName}`),
            react_1.default.createElement(Typography_1.default, { color: "textSecondary", sx: styles.userInfoText }, `${user?.customer?.name}`),
            showExtended &&
                user && [
                react_1.default.createElement(Grid_1.default, { key: "userEmail", container: true, spacing: 1, alignItems: "center" },
                    react_1.default.createElement(Grid_1.default, { item: true },
                        react_1.default.createElement(Email_1.default, { opacity: "0.54", fontSize: "inherit" })),
                    react_1.default.createElement(Grid_1.default, { item: true },
                        react_1.default.createElement(Typography_1.default, { color: "textSecondary" }, user.email ? user.email : notAvailableMessage))),
                react_1.default.createElement(Grid_1.default, { key: "userPhone", container: true, spacing: 1, alignItems: "center" },
                    react_1.default.createElement(Grid_1.default, { item: true },
                        react_1.default.createElement(Smartphone_1.default, { opacity: "0.54", fontSize: "inherit" })),
                    react_1.default.createElement(Grid_1.default, { item: true },
                        react_1.default.createElement(Typography_1.default, { color: "textSecondary" }, user?.phoneNumber ? user.phoneNumber : notAvailableMessage))),
            ])));
};
exports.default = UserCardBase;
